<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" :style="`background-image: url('/assets/images/pages/login-bg_${appFilename}.jpg')`">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div class="vx-col sm:w-full mx-auto self-center d-theme-dark-bg text-center">
              <div class="p-8">
                <div class="vx-card__title">
                  <h1 class="mb-4 fs-1">Parabéns!</h1>
                </div>
                <div class="clearfix mt-8">
                  <iframe width="560" height="315" src="https://www.youtube.com/embed/WnHu-5lX_e0?si=4D0ZTwfFBnQjf1Zp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="mt-8">
                  <a href="/pages/area-de-membros">
                    <button name="button" class="vs-component vs-button vs-button-success vs-button-relief">
                      <span class="vs-button-text vs-button--text"> Acessar Área de Mebros </span>
                      <span
                        class="vs-button-linex"
                        style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"
                      ></span>
                    </button>
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      email: "",
      whatsapp: "",
      affiliate: "",
      appName: process.env.VUE_APP_NAME,
      appFilename: process.env.VUE_APP_FILENAME,
    };
  },
  mounted() {
    if (this.$route.query.aff) {
      localStorage.setItem('aff', this.$route.query.aff)
    }
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.name != "" &&
        this.email != "" &&
        this.whatsapp != ""
      );
    }
  },
  methods: {
    registerUser() {
      if (!this.validateForm) return false;

      this.$api
        .post("/api/v1/auth/register", {
          name: this.name,
          whatsapp: this.whatsapp,
          email: this.email,
          affiliate: localStorage.getItem('aff') || null
        })
        .then((response) => {
          this.$vs.notify({
            time: 6000,
            text: "Sua conta foi criada com sucesso.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          if (response.data.twofactor_active && !response.data.access_token) {
            this.twofactor_active = true
          } else if (response.data.email_security_active && !response.data.access_token) {
            this.email_security_active = true
          } else {
            let Tawk_API = Tawk_API || {}
            Tawk_API.visitor = {
              email: this.email
            }

            this.$localStorage.set('token', response.data.access_token)
            this.$localStorage.set('userId', response.data.user_id)
            this.$localStorage.set(
              'userInfo',
              JSON.stringify({
                email: this.email,
                providerId: 'local',
                uid: 1
              })
            )

            this.$EventBus.$emit('userChanged')

            this.$router.push('/register-v2-thanks')
          }
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            text: error.response.data.errors.join("<br>"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    registerUserSubmit(e) {
      this.registerUser();
      e.preventDefault();
    }
  }
};
</script>
